import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import script from './balance.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.freeToPlayBalance)?_c('magic-corex-dual-balance',{attrs:{"delay":_vm.delay,"currency":_vm.currency,"compact":_vm.compact,"gameplay":_vm.gameplay}}):(_vm.isSweepstakes)?_c('div',[_c('magic-sweepstakes-balance',{attrs:{"delay":_vm.delay,"compact":_vm.compact,"gameplay":_vm.gameplay,"fullscreen":_vm.fullscreen}})],1):_c('magic-corex-currency-balance',{attrs:{"delay":_vm.delay,"currency":_vm.currency,"compact":_vm.compact,"gameplay":_vm.gameplay}},[(_vm.hasExtraItem())?_c('div',{attrs:{"slot":"extra-item"},slot:"extra-item"},[_vm._t("extra-item")],2):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-7e8c8afe";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
